export const hasNestedObjects = <T extends object>(object: T): boolean => {
  return Object.values(object).some(
    nestedPrimitive => typeof nestedPrimitive === 'object'
  )
}
